module.exports = __webpack_public_path__ + "static/media/Pic-0421.73d6b7cc.jpg";